import React from "react";
import { RouteName } from "@/User/Constants/routes";
import route from 'ziggy-js';
import CopyRight from "./CopyRight";
import GroupLink from "./GroupLink";

const Footer = ({ className = '' , showGroupLink}) => {
    return (
        <section id="footer" className={className}>
            <div className="bg-primary">
                <div className="container py-5 my-0 lg:py-10">
                    <a className="block w-fit cursor-pointer underline underline-offset-2 text-white text-base" href="https://zigexn.co.jp/about/company/" >運営会社</a>
                    <a className="block w-fit cursor-pointer underline underline-offset-2 text-white text-base" href={route(RouteName.RulePage)} >利用規約</a>
                    <a className="block w-fit cursor-pointer underline underline-offset-2 text-white text-base" href={route(RouteName.PrivacyPolicyPage)} >個人情報の取扱いについて</a>
                </div>
            </div>

            {showGroupLink && <GroupLink />}
            
            <CopyRight />
        </section>
    );
};

export default Footer;
